import { getEnterprisePlanList } from '@/api/domain/leaseScheme'
import {
  ENTERPRISE_PLAN_STATUS,
  ENTERPRISE_PLAN_STATUS_OPTIONS,
} from './const'
import { categoryList } from '@/store/dict/rentPlanDict'
import { operateMaxShowLength } from '@/store/dict/config'

const RENT_PERIOD_TYPE_MAP = {
  1: '日',
  2: '周',
  3: '月',
}

export default function () {
  const config = {
    formData: {
      formProps: {
        model: {
          id: '',
          name: '',
          brandSeriesModel: {},
          state: '',
        },
      },
      list: [
        // 1. 方案ID
        {
          el: 'input',
          itemConfig: {
            label: '方案ID',
            prop: 'id',
          },
          elConfig: {
            clearable: true,
            placeholder: '请输入方案ID',
          },
          directives: [
            { name: 'number', arg: 'integer' },
          ],
        },
        // 2. 方案名称
        {
          el: 'input',
          itemConfig: {
            label: '方案名称',
            prop: 'name',
          },
          elConfig: {
            clearable: true,
            placeholder: '请输入方案名称',
          },
        },
        // 3. 品牌车系车型
        {
          itemConfig: {
            prop: 'brandSeriesModel',
          },
          elConfig: {
            showModel: true,
          },
          render: 'CarBrandSeriesModel',
        },
        // 4. 方案状态
        {
          el: 'select',
          itemConfig: {
            label: '方案状态',
            prop: 'state',
          },
          elConfig: {
            clearable: true,
            placeholder: '请选择方案状态',
            options: {
              label: 'label',
              value: 'value',
              list: [...ENTERPRISE_PLAN_STATUS_OPTIONS],
            },
          },
        },
      ],
      dealWithSearch: this.dealWithSearch,
      customizeReset: this.customizeReset,
    },
    tableData: {
      columns: [
        // 方案ID
        {
          name: 'id',
          columnProps: {
            prop: 'id',
            label: '方案ID',
            width: 100,
            fixed: 'left',
          },
          render: ({ row }) => {
            return (
              <el-link
                type="primary"
                onClick={() => this.goDetail(row)}
              >
                {row.id}
              </el-link>
            )
          },
        },
        // 方案名称
        {
          name: 'name',
          columnProps: {
            prop: 'name',
            label: '方案名称',
            'min-width': 160,
          },
        },
        // 品牌
        {
          name: 'brandName',
          columnProps: {
            prop: 'brandName',
            label: '品牌',
            'min-width': 100,
          },
        },
        // 车系
        {
          name: 'seriesName',
          columnProps: {
            prop: 'seriesName',
            label: '车系',
            'min-width': 120,
          },
        },
        // 车型
        {
          name: 'modelName',
          columnProps: {
            prop: 'modelName',
            label: '车型',
            'min-width': 180,
          },
        },
        // 租期
        {
          name: 'rentPeriod',
          columnProps: {
            prop: 'rentPeriod',
            label: '租期',
            'min-width': 100,
          },
          getText: ({ row }) => {
            const { rentPeriodType, rentPeriod } = row
            const unit = RENT_PERIOD_TYPE_MAP[rentPeriodType]
            if (rentPeriod != null && unit) {
              return `${rentPeriod}${unit}`
            }
            return '--'
          },
        },
        // 每期租金(元)
        {
          name: 'rentAmount',
          columnProps: {
            prop: 'rentAmount',
            label: '每期租金(元)',
            'min-width': 120,
          },
          getText: ({ row }) =>
            (row.rentAmount != null ? row.rentAmount : '--'),
        },
        // 押金(元)
        {
          name: 'deposit',
          columnProps: {
            prop: 'deposit',
            label: '押金(元)',
            'min-width': 100,
          },
          getText: ({ row }) => (row.deposit != null ? row.deposit : '--'),
        },
        // 租赁类型
        {
          name: 'rentCategory',
          columnProps: {
            prop: 'rentCategory',
            label: '租赁类型',
            'min-width': 100,
          },
          getText: ({ row }) => categoryList[row.rentCategory] || '--',
        },
        // 方案状态
        {
          name: 'state',
          columnProps: {
            prop: 'state',
            label: '方案状态',
            'min-width': 100,
          },
          render: ({ row }) => {
            const tagConfig = {
              [ENTERPRISE_PLAN_STATUS.ON]: { type: 'success', label: '上架' },
              [ENTERPRISE_PLAN_STATUS.OFF]: { type: 'info', label: '下架' },
            }
            const tagCfg = tagConfig[row.state] || { type: 'info', label: '--' }
            return <el-tag type={tagCfg.type}>{tagCfg.label}</el-tag>
          },
        },
        // 操作
        {
          name: 'operate',
          type: 'operate',
          columnProps: {
            label: '操作',
            fixed: 'right',
            width: 180,
          },
          maxShowLength: operateMaxShowLength,
          getOperateList: ({ row }) => {
            const btns = []
            const { state } = row
            const isOn = state === ENTERPRISE_PLAN_STATUS.ON
            const isOff = state === ENTERPRISE_PLAN_STATUS.OFF

            // 上架/下架
            if (this.judgePermission('enterprise_plan_up_and_down')) {
              if (isOff) {
                btns.push({
                  name: 'shelf-on',
                  label: '上架',
                  action: () =>
                    this.handleToggleState(row, ENTERPRISE_PLAN_STATUS.ON),
                })
              }
              if (isOn) {
                btns.push({
                  name: 'shelf-off',
                  label: '下架',
                  action: () =>
                    this.handleToggleState(row, ENTERPRISE_PLAN_STATUS.OFF),
                })
              }
            }

            // 编辑
            if (this.judgePermission('enterprise_plan_edit')) {
              btns.push({
                name: 'edit',
                label: '编辑',
                action: () => this.goEdit(row),
              })
            }

            // 复制
            if (this.judgePermission('enterprise_plan_copy')) {
              btns.push({
                name: 'copy',
                label: '复制',
                action: () => this.goCopy(row),
              })
            }

            return btns
          },
        },
      ],
      apiFn: getEnterprisePlanList,
    },
    isShowDepartment: false,
  }

  return config
}
